import { render, staticRenderFns } from "./Albums.vue?vue&type=template&id=2de166f7&scoped=true&"
import script from "./Albums.vue?vue&type=script&lang=js&"
export * from "./Albums.vue?vue&type=script&lang=js&"
import style0 from "./Albums.vue?vue&type=style&index=0&id=2de166f7&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de166f7",
  null
  
)

component.options.__file = "Albums.vue"
export default component.exports